/** USPS-style secondary designators that belong on address line 2. */
const UNIT_SUFFIX =
  /\s+((?:#\s*[\w-]+)|(?:(?:unit|apt|apartment|suite|ste|bldg|building|fl|floor|rm|room)\.?\s*#?\s*[\w-]+))\s*$/i

/**
 * Splits a street line into the street itself and a trailing unit/apt/suite.
 * Repeats until no suffix remains so duplicated units are collapsed.
 */
export function splitStreetAndUnit(line: string | null | undefined): {
  street: string
  unit: string
} {
  let street = (line ?? '').trim()
  let unit = ''

  while (street) {
    const match = street.match(UNIT_SUFFIX)
    if (!match?.[1] || match.index === undefined) break
    unit = match[1].replace(/\s+/g, ' ').trim()
    street = street.slice(0, match.index).trim()
  }

  return { street, unit }
}
